<template>
  <v-container>
    <v-row>
      <v-col cols="8" offset="2">
        <v-row>
          <v-col align="center">
            <PageTitle :title="label('title')"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col align="center">
            {{label("description1")}}
            <br/>
            {{label("description2")}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" offset="3">
            <ActionButton type="link" to="/">
              {{label("goTop")}}
            </ActionButton>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ComponentMixin from "../../ComponentMixin";
  import PageTitle from "../../atoms/PageTitle";
  import ActionButton from "../../molecules/ActionButton";

  export default {
    mixins: [ComponentMixin],
    type: "page",
    name: "UnsubscribeCompletedPage",
    components: {
      PageTitle,
      ActionButton
    }
  }
</script>

<style scoped>

</style>